var r = TypeError,
  t = function t(_t, e) {
    if (_t < e) throw r("Not enough arguments");
    return _t;
  };
export { t as v };